// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__WsUim","checkboxCol":"Table_checkboxCol__cbLnu","emailCol":"Table_emailCol__3aBZj","actionCol":"Table_actionCol__1n66G"};